import React, {FunctionComponent} from 'react';

import Button, {ButtonProps} from '@material-ui/core/Button';
import Dialog, {DialogProps} from '@material-ui/core/Dialog';
import DialogActions, {DialogActionsProps} from '@material-ui/core/DialogActions';
import DialogContent, {DialogContentProps} from '@material-ui/core/DialogContent';
import DialogContentText, {DialogContentTextProps} from '@material-ui/core/DialogContentText';
import DialogTitle, {DialogTitleProps} from '@material-ui/core/DialogTitle';

export type ConfirmDialogProps = DialogProps & {
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  noCancelButton?: boolean;
  dialogTitleClasses?: DialogTitleProps['classes'];
  dialogContentClasses?: DialogContentProps['classes'];
  dialogContentTextClasses?: DialogContentTextProps['classes'];
  dialogActionsClasses?: DialogActionsProps['classes'];
  confirmButonClasses?: ButtonProps['classes'];
  cancelButonClasses?: ButtonProps['classes'];
  onClose?: ButtonProps['onClick'];
  onConfirm: ButtonProps['onClick'];
  title: string;
  children?: DialogContentTextProps['children'];
};

const Presentational: FunctionComponent<ConfirmDialogProps> = ({
  dialogTitleClasses,
  dialogContentClasses,
  dialogContentTextClasses,
  dialogActionsClasses,
  confirmButonClasses,
  cancelButonClasses,
  confirmButtonLabel,
  cancelButtonLabel,
  onClose,
  onConfirm,
  noCancelButton,
  title,
  children,
  ...otherDialogProps
}) => (
  <Dialog
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    {...otherDialogProps}
  >
    <DialogTitle classes={dialogTitleClasses} id="alert-dialog-title">
      {title}
    </DialogTitle>
    <DialogContent classes={dialogContentClasses}>
      <DialogContentText classes={dialogContentTextClasses} id="alert-dialog-description">
        {children}
      </DialogContentText>
    </DialogContent>
    <DialogActions classes={dialogActionsClasses}>
      {!noCancelButton && (
        <Button classes={cancelButonClasses} onClick={onClose} variant="outlined">
          {cancelButtonLabel}
        </Button>
      )}
      <Button classes={confirmButonClasses} onClick={onConfirm} color="primary" autoFocus>
        {confirmButtonLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

Presentational.defaultProps = {
  cancelButtonLabel: 'Close',
  confirmButtonLabel: 'Confirm',
  onClose: () => null,
  fullWidth: true,
  maxWidth: 'sm',
};

export default Presentational;
